import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const OrderSettingsStyle = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: appColors.lightBackgroundColor,
    },
    tabContainer: {
        flexDirection: "row",
        paddingHorizontal: 15,
        paddingTop: 12,
        paddingBottom: 4,
        gap: 10,
    },
    tabButton: {
        paddingVertical: 8,
        paddingHorizontal: 16,
        borderRadius: 20,
        backgroundColor: appColors.light,
        borderWidth: 1,
        borderColor: appColors.borderColor,
    },
    tabButtonActive: {
        backgroundColor: appColors.primary,
        borderColor: appColors.primary,
    },
    tabText: {
        fontSize: fontSize.smallFontSize,
        fontFamily: appFonts.medium,
        color: appColors.lightDark,
    },
    tabTextActive: {
        color: appColors.light,
        fontFamily: appFonts.bold,
    },
    scrollContent: {
        paddingBottom: 40,
    },
    card: {
        backgroundColor: appColors.light,
        borderRadius: 10,
        marginHorizontal: 15,
        marginTop: 12,
        padding: 18,
        elevation: 2,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.08,
        shadowRadius: 4,
    },
    cardHeaderRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 10,
        marginBottom: 14,
    },
    headerTitleView: {
        flex: 1,
        minWidth: 160,
    },
    cardTitle: {
        fontSize: fontSize.largerFontSize,
        fontFamily: appFonts.bold,
        color: appColors.dark,
    },
    cardSubtitle: {
        fontSize: fontSize.smallFontSize,
        fontFamily: appFonts.medium,
        color: appColors.grey,
        marginTop: 4,
    },
    headerButtonsRow: {
        flexDirection: "row",
        gap: 10,
        alignItems: "center",
    },
    buttonTitleStyle: {
        fontSize: fontSize.smallFontSize,
        fontFamily: appFonts.medium,
        paddingVertical: 0,
        marginVertical: 0,
        includeFontPadding: false,
    },
    backButton: {
        paddingHorizontal: 16,
        paddingVertical: 7,
        minHeight: 36,
        borderRadius: 7,
        borderWidth: 1,
        borderColor: appColors.grey,
        backgroundColor: appColors.light,
        justifyContent: "center",
        alignItems: "center",
    },
    updateButton: {
        paddingHorizontal: 18,
        paddingVertical: 7,
        minHeight: 36,
        borderRadius: 7,
        backgroundColor: appColors.primary,
        justifyContent: "center",
        alignItems: "center",
    },
    addReasonButton: {
        backgroundColor: appColors.primary,
        borderRadius: 6,
        paddingHorizontal: 14,
        paddingVertical: 7,
        minHeight: 32,
        justifyContent: "center",
        alignItems: "center",
    },
    toggleRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingVertical: 12,
    },
    toggleLabelGroup: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
    },
    checkboxItem: {
        backgroundColor: "transparent",
        borderWidth: 0,
        paddingVertical: 6,
        paddingHorizontal: 0,
        marginLeft: 0,
        marginRight: 0,
    },
    checkboxTitle: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.medium,
        color: appColors.lightDark,
        marginLeft: 8,
    },
    optionsContainer: {
        paddingLeft: 6,
        paddingTop: 8,
        gap: 4,
    },
    sectionTitleRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: appColors.borderColor,
        marginBottom: 12,
    },
    sectionTitle: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold,
        color: appColors.lightDark,
    },
    reasonRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingVertical: 4,
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: appColors.borderColor,
    },
    deleteIconContainer: {
        padding: 8,
        borderRadius: 6,
    },
    addReasonRow: {
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
        paddingVertical: 10,
    },
    newReasonInput: {
        flex: 1,
    },
    addActionsRow: {
        flexDirection: "row",
        gap: 8,
    },
    helperText: {
        fontSize: fontSize.smallerFontSize,
        fontFamily: appFonts.medium,
        color: appColors.grey,
        marginTop: 10,
        lineHeight: 18,
    },
    customDaysContainer: {
        marginTop: 12,
        maxWidth: 260,
    },
    // Order ID Card Styles
    orderIdTopRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
        marginBottom: 20,
    },
    orderIdDescText: {
        flex: 1,
        minWidth: 200,
        fontSize: fontSize.smallFontSize,
        fontFamily: appFonts.medium,
        color: appColors.grey,
        lineHeight: 20,
    },
    orderIdExampleBox: {
        backgroundColor: "#E5E7EB",
        borderRadius: 12,
        paddingVertical: 12,
        paddingHorizontal: 28,
        alignItems: "center",
        justifyContent: "center",
        minWidth: 180,
    },
    orderIdExampleLabel: {
        fontSize: fontSize.smallerFontSize,
        fontFamily: appFonts.medium,
        color: appColors.dark,
        marginBottom: 4,
    },
    orderIdExampleValue: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold,
        color: appColors.dark,
        letterSpacing: 0.5,
    },
    orderIdInputsRow: {
        flexDirection: "row",
        gap: 20,
        flexWrap: "wrap",
    },
    orderIdInputCol: {
        flex: 1,
        minWidth: 200,
    },
    topActionBar: {
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
        marginHorizontal: 15,
        marginTop: 10,
        marginBottom: 2,
    },
});
